'use client'

import * as React from 'react'
import { Separator as SeparatorPrimitive } from '@base-ui/react/separator'

import cn from '@config/tailwind/cn'

function Separator({ className, orientation = 'horizontal', ...props }: SeparatorPrimitive.Props) {
  return (
    <SeparatorPrimitive
      data-slot='separator'
      orientation={orientation}
      className={cn(
        'ui:bg-outline ui:shrink-0 ui:data-[orientation=horizontal]:h-px ui:data-[orientation=horizontal]:w-full ui:data-[orientation=vertical]:w-px ui:data-[orientation=vertical]:self-stretch',
        className,
      )}
      {...props}
    />
  )
}

export { Separator }
